export const AddColumnToNormalizationFormFields = {
	columnFieldName: "columnName",
	dataTypeFieldName: "dataType",
	valueTypeFieldName: "valueType",
};

export const CommissionsWizardFormFields = {
	// Fee Items Step
	feeItemsFieldName: "feeItems",
	feesFieldArray: {
		arrayName: "fees",
		feeMappingFieldArray: {
			arrayName: "feesMapping",
			feeFromColumnFieldName: "feeFromColumn",
			feeNormalizationSummaryFieldName: "feeNormalizationSummary",
		},
	},
};
